// import UrlParams from '@root/libs/url-params/url-params-module';
// export default UrlParams;


// -> {
// 	query: {
// 		key: value,
// 	},
// 	hash: {
// 		key: value,
// 	},
// }
const get = url => {
	var query = (url ? (url.split('?')[1] || '').split('#')[0] : window.location.search.substr(1));
	query = decodeURIComponent(query);
	var hash = (url ? (url.split('#')[1] || '') : window.location.hash.substr(1));
	hash = decodeURIComponent(hash);

	var queryParsed = parseParams(query);
	var hashParsed = parseParams(hash);

	return {
		query: queryParsed.params,
		queryLower: queryParsed.paramsLower,
		hash: hashParsed.params,
		hashLower: hashParsed.paramsLower,
	}
}
const parseParams = query => {
	var vars = query.split('&');
	var params = {};
	var paramsLower = {};
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		if(!pair[0]){
			continue;
		}

		var name = pair[0];
		var value = decodeURIComponent(pair[1]);

		var isArray = name.indexOf('[]') > -1;
		if(isArray){
			name = name.split('[]').join('');
		}
		var nameLower = name.toLowerCase();

		if(isArray){
			params[name] = value.split('|').filter(_ => !!_);
			paramsLower[nameLower] = value.split('|').filter(_ => !!_);
		}else{
			params[name] = value;
			paramsLower[nameLower] = value;
		}
	}
	return {
		params: params,
		paramsLower: paramsLower,
	};
}

// data: {
// 	query: {
// 		key: value,
// 	},
// 	hash: {
// 		key: value,
// 	},
// }
const extend = (url, data) => {
	var params = get(url);
	var newQuery = $.extend({}, params.query, data.query || {});
	var newHash = $.extend({}, params.hash, data.hash || {});
	var queryStr = [];
	for(var i in newQuery){
		if(newQuery[i]){
			queryStr.push(i+'='+newQuery[i]);
		}
	}
	var hashStr = [];
	for(var i in newHash){
		if(newHash[i]){
			hashStr.push(i+'='+newHash[i]);
		}
	}
	return url.split('#')[0].split('?')[0] +
		(queryStr.length > 0 ? '?'+ queryStr.join('&') : '') +
		(hashStr.length ? '#'+hashStr.join('&') : '');
}

const generate = data => {
	return Object.entries(data).map(([name, value]) => {
		if(Array.isArray(value)){
			return `${name}[]=${encodeURIComponent(value.join('|'))}`;
		}else{
			return `${name}=${encodeURIComponent(value)}`;
		}
	}).join('&');
}

export default {
	extend,
	get,
	generate,
}
